export const getRandomArray = (max, count) => {
  let result = [];

  const getShuffledBatch = (n) => {
    let batch = Array.from({ length: n }, (_, i) => i);
    for (let i = batch.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [batch[i], batch[j]] = [batch[j], batch[i]];
    }
    return batch;
  };

  while (result.length < count) {
    const nextBatch = getShuffledBatch(max);
    result = [...result, ...nextBatch];
  }

  return result.slice(0, count);
};
